<template>
  <div class="hello">
    <div class="topOperation">
      <div></div>
      <div class="top-right">
        <el-button class="exportButton1" type="primary" :loading="btnLoading" :disabled="tableData == [] || tableData.length <= 0" @click="exportHandle">导出</el-button>
        <el-button class="exportButton" @click="putStorage">强制入库</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/employee-fnnchis' }">导入记录</el-breadcrumb-item>
          <el-breadcrumb-item>财务清单勘误</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable3">
        <el-table :data="tableData" :max-height="tableHeight-180" border style="width: 99%" v-loading="listLoading" @selection-change="handleSelectionChange" @cell-dblclick="showEditInput" :lazy="true" :cell-style="columnStyle">
          <el-table-column align="center" type="selection" width="40"></el-table-column>
          <!-- <el-table-column align="center" fixed label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" prop="reason" fixed label="错误原因" width="100">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.reason" placement="bottom" effect="light">
                <img src="../../assets/employee/images/warning.png" alt="" style="width: 24px" />
              </el-tooltip>
            </template>
          </el-table-column>
          <template v-for="(item, index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" :key="index" width="200" align="center">
              <template slot-scope="scope">
                <div v-show="item.StrColumName == '身份证号码'">
                  <!-- <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  (scope.row.EditName == scope.column.property)&&item.StrColumName == '身份证号码'
                ">
                    <el-input v-model="qdata.StrIdCard" :id="scope.row.IntExcelLine + scope.column.id" @blur="editIdCard(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
                  </div> -->
                  <div>
                    <div v-if="scope.row.showError.indexOf('StrIdCard') != -1">
                      <el-tooltip :content="
                          scope.row.showError[
                            scope.row.showError.indexOf('StrIdCard') + 1
                          ].reason
                        " placement="bottom" effect="light">
                        <div class="errorShow">
                          {{ scope.row.StrIdCard ? scope.row.StrIdCard : "-" }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>{{ scope.row.StrIdCard }}</div>
                  </div>
                </div>
                <div v-show="item.StrColumName == '项目名称'">
                  <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                 (scope.row.EditName == scope.column.property)&&item.StrColumName == '项目名称'
                ">
                    <el-input v-model="qdata.StrJobInf" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
                  </div>
                  <div v-if="
                      !scope.row.isEdit ||
                      scope.row.EditName != scope.column.property
                    ">
                    <div v-if="scope.row.showError.indexOf('StrObjName') != -1">
                      <el-tooltip :content="
                          scope.row.showError[
                            scope.row.showError.indexOf('StrObjName') + 1
                          ].reason
                        " placement="bottom" effect="light">
                        <div class="errorShow">
                          {{ scope.row.StrObjName ? scope.row.StrObjName : "-" }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>{{ scope.row.StrObjName }}</div>
                  </div>
                </div>
                <div v-show="item.StrColumName != '身份证号码'&&item.StrColumName != '项目名称'">
                  <div v-if="
                      !scope.row.isEdit ||
                      scope.row.EditName != scope.column.property
                    ">
                    <span v-if="item.StrColumName.indexOf('收入')!=-1 || item.StrColumName.indexOf('金')!=-1 || item.StrColumName.indexOf('支出')!=-1 || item.StrColumName.indexOf('结余')!=-1 || item.StrColumName.indexOf('商保')!=-1 || item.StrColumName.indexOf('险')!=-1 || item.StrColumName.indexOf('个人承担')!=-1">
                      {{!isNull(scope.row[item.StrColumId])?scope.row[item.StrColumId].toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}
                    </span>
                    <span v-else-if="item.StrColumName=='插入时间'">{{isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId].substring(0, 10)}}</span>
                    <span v-else>{{!isNull(scope.row[item.StrColumId])?scope.row[item.StrColumId]:''}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="listQuery.currpage" :page-size="listQuery.pagecount" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="this.totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 修改身份证 -->
      <el-dialog :visible.sync="dialogVisibleIdCard" width="580px">
        <div class="delTitle">修改身份证号码</div>
        <div class="updateContract">
          <div class="upLeft">
            <div>身份证号码</div>
            <div class="dataSele">
              <el-input size="small" v-model="idInfo.idcard"></el-input>
            </div>
          </div>
        </div>
        <div class="tips">注：<span class="point">港澳台 &nbsp;&nbsp;</span>以及 <span class="point">&nbsp;&nbsp;外籍&nbsp;&nbsp;</span>雇员请补全<span class="point">&nbsp;&nbsp;性别、出生年月&nbsp;&nbsp;</span>信息,大陆雇员不需要补充！</div>
        <div class="updateContract" style="margin-top:15px">
          <div class="upLeft">
            <div>性别</div>
            <div class="dataSele">
              <el-select v-model="idInfo.sex" clearable slot="prepend" placeholder="请选择">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </div>
          </div>
          <div class="upLeft">
            <div>出生年月</div>
            <div class="dataSele">
              <el-date-picker v-model="idInfo.birth" clearable  type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisibleIdCard = false">取消</button>
          <button class="search" @click="editIdCard" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import FUN from "../../fun";
import xz from "../../common";
export default {
  name: "financialError",
  data() {
    return {
      //修改身份证弹窗
      dialogVisibleIdCard: false,
      idInfo: {
        idcard: '',
        sex: '',
        birth: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }]
      },
      tableHeight: 0,
      chooseInfo: true,
      btnLoading: false,
      listLoading: false,
      fullscreenLoading: false,
      remark: "",
      blacklistReason: "",
      //下拉项目名称
      strsrvcentSel: "",
      objList: [],
      //下级人员列表(负责客服)
      subordinateList: [],
      lsdata: "",
      path: "",
      qdata: [],
      empinfo: "",

      instname: "",
      servusrname: "",
      servcentname: "",
      custname: "",
      entid: "",
      infoPath: "",
      totalmain: "",
      inputValue: "",
      tableData: [],
      currentPage3: 1,
      isIndeterminate: true,
      //手机号码格式是否正确
      phoneJudge: "",
      contTelJudge: "",
      totalcount: null,
      //错误数
      errorLength: "",
      //表头内容
      tableTitle: [],
      custNameExport: "",
      multipleSelection: [],
      //勘误列表参数
      listQuery: {
        pagecount: 10,
        currpage: 1,
        status: 0,
        strexcelpath: this.$route.query.strexcelpath
      },
      //表头参数
      topQuery: {
        pagecount: 10000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed: "all",//strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
        strTableId: ''
      },
      //导出参数
      exportQuery: {
        pagecount: 100000,
        currpage: 1,
        status: 0,
        strexcelpath: ""
      },
      custNameExport: '',
      exportTableId: ''
    };
  },
  created() {
    this.calHeight();
    this.listQuery.strexcelpath = this.$route.query.strexcelpath
    this.custNameExport = this.$route.query.custname;
    this.topQuery.strTableId = this.$route.query.strTableId;
    this.exportTableId = this.$route.query.strTableId;
    this.exportQuery.strexcelpath = this.$route.query.strexcelpath
    this.getImportFiledList();
    this.getErrorInfo();
    //下拉客服
    this.getMemberList();
    //下拉项目名称
    this.getObjList(this.strsrvcentSel);
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height', this.tableHeight)
    },
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
    },
    //导出
    exportHandle() {
      this.btnLoading = true;
      xz.errorfinanceDataTable(this.custNameExport, this.exportTableId, this.exportQuery).then(
        (res) => {
          // console.log('导出',res)
          if (res.status == 'ok') {
            this.$router.push({
              path: "/employee-fnnchis",
              query: {
                custname: res.msg,
                isExport: true,
                showPage: 1,
                isActive: 1,
                qStstus: 1
              }
            });
          } else {
            this.$message({
              message: "导出错误",
              type: "error"
            })
          }
          this.btnLoading = false;
        }
      );
    },
    //修改信息(input)
    editEmployee(row, column) {
      var cluvalue = document.getElementById(row.IntExcelLine + column.id).value;
      if (this.oldCluvalue == cluvalue) {
        this.$delete(row, "isEdit");
        this.$delete(row, "EditName");
        return;
      }
      const editData = {
        tableid: this.topQuery.strTableId,
        excelpath: row.StrExcelPath,
        execlline: row.IntExcelLine,
        cluname: column.property,
        cluvalue: cluvalue
      }
      xz.modifyfinancecurrimpdata(editData).then((res) => {
        if (res == true) {
          row = this.qdata;
          this.$message({
            message: "雇员信息修改成功！",
            type: "success",
          });
          window.localStorage.setItem("finnaKey", true);
          this.getErrorInfo();
        } else {
          this.$message.error("雇员信息修改失败！");
          this.getErrorInfo();
        }
      });
      // row.showError.splice(row.showError.indexOf(column.property),1)
      // console.log('sad',column.property)
      if (row.showError.indexOf(column.property) != -1) {
        row.showError.splice(row.showError.indexOf(column.property), 1);
      }
      this.$delete(row, "isEdit");
      this.$delete(row, "EditName");
      console.log(row);
    },
    handleCurrentChange(val) {
      if (window.localStorage.getItem("finnaKey")) {
        this.$message({
          message: "请先保存修改过的数据",
          type: "warning",
        });
        this.listQuery.currpage = 1;
      } else {
        this.listQuery.currpage = Number(val);
        this.getErrorInfo();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.listQuery.currpage = 1;
      this.listQuery.pagecount = parseInt(val);
      this.getErrorInfo();
    },
    //获取表头信息
    getImportFiledList() {
      xz.getfinanceempcolumninf(this.topQuery).then((res) => {
        // console.log('表头',res)
        if (res) {
          this.tableTitle = res.data;
        }
      });
    },
    //下级人员列表
    getMemberList() {
      xz.getallEmplowertListInfo().then((res) => {
        // console.log('下级人员列表',res)
        if (res.data && Array.isArray(res.data)) {
          this.subordinateList = res.data;
        } else {
          this.subordinateList = [];
        }
      });
    },
    //下拉项目名称
    getObjList(strsrvcent) {
      xz.getsrarchinstobjlist(strsrvcent).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          if (
            apartmentData.StrObjName != "" &&
            apartmentData.StrObjName != " "
          ) {
            dataList.push({ StrObjName: apartmentData.StrObjName });
          }
        }
        // console.log("getServeList", dataList);
        this.objList = dataList;
      });
    },
    //双击单元格编辑雇员信息
    showEditInput(row, column, cell, event) {
      if (column.label == '身份证号码') {
        this.idInfo.idcard = row.StrIdCard;
        this.dialogVisibleIdCard = true;
        this.qdata = row;
        this.$set(row, "isEdit", true);
        this.$set(row, "EditName", column.property);
        // console.log("colum", row, column, cell, event);
        setTimeout(() => {
          // document.getElementById(row.IntExcelLine + column.id).focus();
          this.oldCluvalue = document.getElementById(
            row.IntExcelLine + column.id
          ).value;
        }, 0);
        return
      }
      if (column.label == '项目名称') {
        this.qdata = row;
        this.$set(row, "isEdit", true);
        this.$set(row, "EditName", column.property);
        setTimeout(() => {
          this.oldCluvalue = document.getElementById(
            row.IntExcelLine + column.id
          ).value;
        }, 0);
        return
      }
    },
    //修改身份证
    editIdCard() {
      let idcode = this.idInfo.idcard;
      if (idcode) {
        if (idcode.length == 18) {
          //身份证格式校验
          // 加权因子
          let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          // 校验码
          let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
          let code = idcode + "";
          let last = idcode[17]; //最后一个
          let seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          let arr = seventeen.split("");
          let len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          let resisue = num % 11;
          let last_no = check_code[resisue];
          let idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          let format = idcard_patter.test(idcode);
          if (last === last_no && format == true) {
            this.saveIdcard(idcode)
          } else {
            this.$message.error("身份证格式错误！请核对身份证信息");
            this.getErrorInfo();
          }
        } else {
          if (this.idInfo.sex && this.idInfo.birth) {
            if (idcode.length >= 12) { 
              this.$message({
              message: '如果是港澳台或者外籍人员，请输入正确的号码，如果是大陆雇员，请不要填性别、出生年月信息',
              showClose: true,
              type: 'error',
              duration: 5000
              })
            return
            }
            let birth = this.idInfo.birth.replace(/\-/g, "");
            let idcard = this.idInfo.idcard + '-' + birth + '-' + this.idInfo.sex;
            this.saveIdcard(idcard)
          }
          else if (this.idInfo.idcard == '其他收入1' || this.idInfo.idcard == '其他收入2' || this.idInfo.idcard == '其他收入3') {
            this.saveIdcard(this.idInfo.idcard)
          }
          else {
            this.$message({
              message: '如果是港澳台或者外籍人员，请完善性别、出生年月信息，如果是大陆雇员，请输入正确的身份证号码',
              showClose: true,
              type: 'error',
              duration: 5000
            })
          }
        }
      }
    },
    //保存身份证号码
    saveIdcard(idcard) {
      const data = {
        tableid: this.topQuery.strTableId,
        excelpath: this.qdata.StrExcelPath,
        execlline: this.qdata.IntExcelLine,
        cluname: 'StrIdCard',
        cluvalue: idcard,
      };
      // console.log('保存身份证',data)
      xz.modifyfinancecurrimpdata(data).then((res) => {
        if (res == true) {
          this.$message({
            message: "雇员信息修改成功！",
            type: "success",
          });
          this.getErrorInfo();
        } else {
          this.$message.error("雇员信息修改失败！");
          this.getErrorInfo();
        }
        this.dialogVisibleIdCard = false
      });
    },
    // 获取出错信息
    getErrorInfo() {
      this.listLoading = true;
      // const delInfo = [];
      xz.getfinanceimperrdata(this.listQuery).then((res) => {
        // console.log("出错信息", res);
        let i = 1 + (this.currpage - 1) * 10;
        if (res.data && res.data.length > 0) {
          res.data.forEach((l) => {
            l["num"] = i++;
          });
          var arr;
          var arr2;
          res.data.forEach((j) => {
            this.$set(j, "showError", []);
            arr = j.innerOtherinf.split("|");
            // console.log('qq',arr)
            arr.forEach((k) => {
              arr2 = k.split(":");
              j.showError.push(arr2[1], { reason: arr2[3] });
              // console.log('q2',j.showError.indexOf(arr2[1]))
            });
          });
          this.tableData = res.data;
          this.showError();
          this.totalcount = parseInt(res.totalcount);
          //获取性别 年龄等
          this.getPsInfo();
        } else {
          this.custNameExport = "";
          this.tableData = [];
          this.totalcount = 0;
        }
        this.listLoading = false;
      });
    },
    //处理错误数据
    showError() {
      let arr;
      let arr2;
      this.tableData.forEach((l) => {
        this.$set(l, "showError", []);
        // this.$set(l,"reason",[])
        arr = l.innerOtherinf.split("|");
        // console.log('qq',arr)
        arr.forEach((k) => {
          arr2 = k.split(":");
          arr2[1] = arr2[1].replace(arr2[1][0], arr2[1][0].toUpperCase());
          l.showError.push(arr2[1], { reason: arr2[3] });
          let rea = arr2[2] + ":" + arr2[3];
          if (l.reason) {
            l.reason = l.reason + "；" + rea;
          } else {
            l["reason"] = rea;
          }
          // console.log('q2',arr2[1])
        });
      });
      console.log("list", this.tableData);
    },
    //获取出生年月、性别、年龄
    getPsInfo() {
      this.tableData.forEach((l) => {
        if (!this.isNull(l.StrIdCard)) {
          if (l.StrIdCard.length == 18) {
            let idcode = l.StrIdCard;
            // console.log('idcode', idcode)
            // 加权因子
            let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,];
            // 校验码
            let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
            let code = idcode + "";
            let last = idcode[17].toUpperCase(); //最后一个
            let seventeen = code.substring(0, 17);
            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            let arr = seventeen.split("");
            let len = arr.length;
            let num = 0;
            for (let i = 0; i < len; i++) {
              num = num + arr[i] * weight_factor[i];
            }
            // 获取余数
            let resisue = num % 11;
            let last_no = check_code[resisue];

            // 格式的正则
            // 正则思路
            // var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
            let idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
            // 判断格式是否正确
            let format = idcard_patter.test(idcode);
            let idcardJudge = null;
            console.log('idcode', last)
            if (last === last_no && format == true) {
              // console.log(1111)
              idcardJudge = "true";
            } else {
              // console.log(222)
              idcardJudge = "false";
            }

            // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码

            //获取出生年月、性别、年龄
            let myDate = new Date();
            let month = myDate.getMonth() + 1;
            let day = myDate.getDate();
            let iden = idcode;
            let sexnum = null;
            let sex = null;
            let birth = null;
            let age = 0;
            age = myDate.getFullYear() - iden.substring(6, 10) - 1;
            sexnum = iden.substring(16, 17);
            if (sexnum % 2 === 0) {
              sex = "女";
            } else {
              sex = "男";
            }
            birth =
              iden.substring(6, 10) +
              "-" +
              iden.substring(10, 12) +
              "-" +
              iden.substring(12, 14);
            if (
              iden.substring(10, 12) < month ||
              (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
            )
              age++;
            l["birth"] = birth;
            l["sex"] = sex;
            l["age"] = age;
            l["idcardJudge"] = idcardJudge;
          } else {
            let count = this.searchChar(l.StrIdCard);
            let arr = [];
            if (count == 0) {
              // console.log(3333)
              l["birth"];
              l["sex"];
              l["age"];
              if (l.StrIdCard == '其他收入1' || l.StrIdCard == '其他收入2' || l.StrIdCard == '其他收入3') {
                l["idcardJudge"] = 'true';
              } else {
                l["idcardJudge"] = 'false';
              }
            } else if (count == 2) {
              // console.log(444)
              l["idcardJudge"] = 'true';
              arr = l.StrIdCard.split('-')
              console.log('arr=', arr)
              l["StrIdCard"] = arr[0];
              let sex = arr[2] == '1' ? '男' : '女';
              let birth = arr[1].split('');
              birth.splice(4, 0, '-');
              birth.splice(7, 0, '-');
              birth = birth.join("");
              let myDate = new Date();
              let month = myDate.getMonth() + 1;
              let day = myDate.getDate();
              let age = myDate.getFullYear() - arr[1].substring(0, 4) - 1;
              if (
                arr[1].substring(4, 6) < month ||
                (arr[1].substring(4, 6) == month && arr[1].substring(6, 8) <= day)
              )
                age++;
              l["birth"] = birth;
              l["sex"] = sex;
              l["age"] = age;
            } else {
              l["idcardJudge"] = 'false';
            }
          }
        }
      });
    },
    //判断'-'出现几次
    searchChar(str) {
      let count = 0;
      let origialLength = str.length;
      str = str.replace(/\-/g, "");
      let newLength = str.length;
      count = origialLength - newLength;
      return count;
    },
    //选择行
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log('val', val)
      console.log('mul', this.multipleSelection, this.chooseInfo)
    },
    //强制入库
    putStorage() {
      this.chooseInfo = true;
      let info = [];
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((element) => {
          console.log('fgf', element)
          info.push({
            excelpath: element.StrExcelPath,
            execlline: element.IntExcelLine,
          });
          if (element.idcardJudge == "false") {
            this.chooseInfo = false;
          }
          // if (element.idcardJudge == "false"&&(element.StrIdCard == "其他收入1"||element.StrIdCard == "其他收入2"||element.StrIdCard == "其他收入3")) {
          //   this.chooseInfo = true;
          // }
        });
      } else {
        info = [];
      }
      // console.log('info',info,this.chooseInfo)
      const odata = {
        tableid: this.$route.query.strTableId,
        datainf: info
      }
      if (this.isNull(info)) {
        this.$message({
          message: '请选择要入库的数据',
          type: 'warning'
        });
        return false
      } else {
        if (this.chooseInfo) {
          xz.updatefinancemodifydata(odata).then(res => {
            this.$message({
              message: '正在入库中，入库可能会有延迟，请稍等',
              type: 'warning'
            });
            window.localStorage.removeItem('finnaKey');

            let _this = this
            setTimeout(function () {
              _this.getErrorInfo();
              _this.$store.commit("getLeftNum");
            }, 2000);
          })
        } else {
          this.$message.error("选中的数据中有身份证格式错误的或者港澳台、外籍人员信息未补充完整的，请修改后再入库")
        }
      }
    },
    columnStyle({ row }) {
      if (row.showdel) {
        return "text-decoration:line-through";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.errorShow {
  background: rgb(255, 67, 98);
}
.topOperation .exportButton {
  height: 32px;
  padding: 5px 15px;
  margin-right: 10px;
  border-radius: 5px;
  background-color: #19bd92;
  border: 1px dashed #19bd92;
  color: #fff;
}
.topOperation .exportButton1 {
  height: 32px;
  padding: 5px 15px;
  margin-right: 5px;
  border-radius: 5px;
  background-color: #409eff;
  border: 1px dashed #409eff;
  color: #fff;
}
:focus {
  outline: 0;
}
.top-right {
  display: flex;
  align-items: center;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  position: relative;
  top: 5px;
  left: 0;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tips {
  margin-top: 20px;
  color: red;
}
.point {
  font-weight: 600;
}
</style>


<style >
.customerRosterTable3 .el-table td {
  padding: 8px 0;
}
.customerRosterTable3 .el-table th {
  padding: 12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 56px;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card > .el-tabs__content {
  max-height: 200px;
  overflow-y: scroll;
}
.dialog .el-card__body {
  max-height: 208px;
  overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
  margin-left: 10px;
}
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19bd92;
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #19bd92;
}
.tagArea .el-checkbox__inner:hover {
  border-color: #19bd92;
}
.tagArea .el-tag--plain.el-tag--success {
  color: #19bd92;
}
.tagArea
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92;
}
.tagArea .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #19bd92;
}
.tableEditInput .el-input__inner {
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0;
  font-size: 13px;
}
.tableEditInput .el-input__icon {
  line-height: 25px;
}
.el-select-dropdown__item.selected {
  color: #19bd92 !important;
}
</style>